function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { normalizeSize } from '../../utils';

var Checkbox = function Checkbox(props) {
  var className = props.className,
      children = props.children,
      disabled = props.disabled,
      wrapperClassName = props.wrapperClassName,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["className", "children", "disabled", "wrapperClassName", "size"]);

  var checkboxClass = classNames('checkbox__mark bs-border bc-neutral-500 bw-1 ba', className);
  var wrapperClass = classNames('checkbox w-100p', {
    'checkbox__disabled': disabled
  }, wrapperClassName);
  return React.createElement("label", {
    className: wrapperClass
  }, React.createElement("div", {
    className: "flex flex-start p-relative flex-middle"
  }, React.createElement("input", _extends({
    type: "checkbox",
    disabled: disabled,
    className: "checkbox__input o-0"
  }, otherProps)), React.createElement("span", {
    className: checkboxClass
  })), children);
};

Checkbox.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  wrapperClassName: PropTypes.string
};
Checkbox.defaultProps = {
  className: '',
  children: '',
  disabled: false,
  wrapperClassName: ''
};
export default React.memo(Checkbox);